var ActionFactories, PlaceEngine;

ActionFactories = require('../state/ActionFactories');

PlaceEngine = (function() {
  function PlaceEngine(store) {
    this.store = store;
    this.service = null;
  }

  PlaceEngine.prototype.getService = function() {
    var el, map;
    if (!this.store.getState().apiLoaded) {
      return null;
    }
    if (this.service === null) {
      el = document.createElement('div');
      map = new google.maps.Map(el, {
        center: {
          lat: -33.866,
          lng: 151.196
        },
        zoom: 17
      });
      this.service = new google.maps.places.PlacesService(map);
    }
    return this.service;
  };

  PlaceEngine.prototype.search = function(centre) {
    var average, request, service;
    service = this.getService();
    average = this.store.getState().average;
    console.log('search', service, average);
    if (!(service !== null && average !== null)) {
      return;
    }
    request = {
      location: average,
      rankBy: google.maps.places.RankBy.DISTANCE,
      types: ['bar', 'restaurant']
    };
    return service.nearbySearch(request, this.handleResults.bind(this));
  };

  PlaceEngine.prototype.handleResults = function(results, status) {
    var r;
    console.log('handleResults', results, status);
    r = status === google.maps.places.PlacesServiceStatus.OK ? results.slice(0, 8) : [];
    return this.store.dispatch(ActionFactories.placesChanged(r));
  };

  return PlaceEngine;

})();

module.exports = PlaceEngine;

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3dvcmsvc3JjL2xpYi9QbGFjZUVuZ2luZS5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvd29yay9zcmMvbGliL1BsYWNlRW5naW5lLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBOztBQUFBLGVBQUEsR0FBa0IsT0FBQSxDQUFRLDBCQUFSOztBQUVaO0VBQ1EscUJBQUMsS0FBRDtJQUFDLElBQUMsQ0FBQSxRQUFEO0lBQ2IsSUFBQyxDQUFBLE9BQUQsR0FBVztFQURDOzt3QkFHYixVQUFBLEdBQVksU0FBQTtBQUNYLFFBQUE7SUFBQSxJQUFBLENBQW1CLElBQUMsQ0FBQSxLQUFLLENBQUMsUUFBUCxDQUFBLENBQWlCLENBQUMsU0FBckM7QUFBQSxhQUFPLEtBQVA7O0lBRUEsSUFBRyxJQUFDLENBQUEsT0FBRCxLQUFZLElBQWY7TUFDQyxFQUFBLEdBQUssUUFBUSxDQUFDLGFBQVQsQ0FBdUIsS0FBdkI7TUFDTCxHQUFBLEdBQU0sSUFBSSxNQUFNLENBQUMsSUFBSSxDQUFDLEdBQWhCLENBQW9CLEVBQXBCLEVBQXdCO1FBQzdCLE1BQUEsRUFBUTtVQUFDLEdBQUEsRUFBSyxDQUFDLE1BQVA7VUFBZSxHQUFBLEVBQUssT0FBcEI7U0FEcUI7UUFFN0IsSUFBQSxFQUFNLEVBRnVCO09BQXhCO01BSU4sSUFBQyxDQUFBLE9BQUQsR0FBVyxJQUFJLE1BQU0sQ0FBQyxJQUFJLENBQUMsTUFBTSxDQUFDLGFBQXZCLENBQXFDLEdBQXJDLEVBTlo7O1dBUUEsSUFBQyxDQUFBO0VBWFU7O3dCQWFaLE1BQUEsR0FBUSxTQUFDLE1BQUQ7QUFDUCxRQUFBO0lBQUEsT0FBQSxHQUFVLElBQUMsQ0FBQSxVQUFELENBQUE7SUFDVixPQUFBLEdBQVUsSUFBQyxDQUFBLEtBQUssQ0FBQyxRQUFQLENBQUEsQ0FBaUIsQ0FBQztJQUM1QixPQUFPLENBQUMsR0FBUixDQUFZLFFBQVosRUFBc0IsT0FBdEIsRUFBK0IsT0FBL0I7SUFFQSxJQUFBLENBQUEsQ0FBYyxPQUFBLEtBQWEsSUFBYixJQUFzQixPQUFBLEtBQWEsSUFBakQsQ0FBQTtBQUFBLGFBQUE7O0lBRUEsT0FBQSxHQUFVO01BQ1QsUUFBQSxFQUFVLE9BREQ7TUFFVCxNQUFBLEVBQVEsTUFBTSxDQUFDLElBQUksQ0FBQyxNQUFNLENBQUMsTUFBTSxDQUFDLFFBRnpCO01BR1QsS0FBQSxFQUFPLENBQUMsS0FBRCxFQUFRLFlBQVIsQ0FIRTs7V0FLVixPQUFPLENBQUMsWUFBUixDQUFxQixPQUFyQixFQUE4QixJQUFDLENBQUEsYUFBYSxDQUFDLElBQWYsQ0FBb0IsSUFBcEIsQ0FBOUI7RUFaTzs7d0JBY1IsYUFBQSxHQUFlLFNBQUMsT0FBRCxFQUFVLE1BQVY7QUFDZCxRQUFBO0lBQUEsT0FBTyxDQUFDLEdBQVIsQ0FBWSxlQUFaLEVBQTZCLE9BQTdCLEVBQXNDLE1BQXRDO0lBQ0EsQ0FBQSxHQUFPLE1BQUEsS0FBVSxNQUFNLENBQUMsSUFBSSxDQUFDLE1BQU0sQ0FBQyxtQkFBbUIsQ0FBQyxFQUFwRCxHQUNILE9BQVEsWUFETCxHQUVDO1dBQ0wsSUFBQyxDQUFBLEtBQUssQ0FBQyxRQUFQLENBQWdCLGVBQWUsQ0FBQyxhQUFoQixDQUE4QixDQUE5QixDQUFoQjtFQUxjOzs7Ozs7QUFPaEIsTUFBTSxDQUFDLE9BQVAsR0FBaUIifQ==
